import type { FC } from "react";
import styles from "./Layout.module.css";

interface LayoutProps {
  children?: React.ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }) => {
  return <section className={styles.layout}>{children}</section>;
};
